<ds-themed-item-detail-preview [item]="item"
                        [object]="object"
                        [status]="status"></ds-themed-item-detail-preview>

<ds-workspaceitem-actions [object]="dso"></ds-workspaceitem-actions>
